<div class="indicators-list">
    <div class="indicator-info pointer" *ngFor="let indicator of indicators; index as i" [ngClass]="{'display-none': indicator.indicatorName<=0}">
        <div class="indicator-subinfo width-100" (click)="editIndicator(indicator, i)">
            <span class="fixed-period">{{getFixedPeriod(indicator)}} | </span> 
            <span class="indicator-name">{{getIndicatorName(indicator)}}</span>   
        </div>
        <cross-svg class="cross" [size]="14" (click)="deleteIndicator(indicator)"></cross-svg>
    </div>
</div>